import { render, staticRenderFns } from "./CardApartment.vue?vue&type=template&id=5b1a82fc&scoped=true"
import script from "./CardApartment.vue?vue&type=script&lang=js"
export * from "./CardApartment.vue?vue&type=script&lang=js"
import style0 from "./CardApartment.vue?vue&type=style&index=0&id=5b1a82fc&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b1a82fc",
  null
  
)

export default component.exports